<div class="ui-modal add-person-by-image-dialog">
  <div class="header flex-row space-between-center">
    {{ 'PERSONS.UPLOAD_DIALOG.ADD_PERSON' | translate }}
    <span class="ui-icon-close c-p" [class.disabled]="isBusy()" (click)="closeDialog()"></span>
  </div>

  <div class="body flex-col start-start flex dialog-content narrower-input">
    @if (shouldShowUploadSection()) {
      @if (selectedFileName()) {
        <div class="file-list-wrapper flex-col start-start p-r">
          <div class="flex-row center-center gap-8 mb-16">
            <svg viewBox="0 0 36 36" class="circular-chart">
              <circle class="circle-bg" cx="18" cy="18" r="15.9155"></circle>
              <circle
                class="circle"
                cx="18"
                cy="18"
                r="15.9155"
                stroke-dasharray="100"
                [attr.stroke-dashoffset]="100 - progress()"
              ></circle>
            </svg>
            <div class="progress">{{ progress() }}%</div>
          </div>
          <div class="w-100 flex-row start-center gap-8 uploaded-file">
            <span class="ui-icon-images"></span>
            <div>{{ selectedFileName() }}</div>
          </div>
          @if (isEvaluating()) {
            <div class="upload-status">{{ 'PERSONS.UPLOAD_DIALOG.EVALUATING' | translate }}</div>
          }
        </div>
      } @else {
        <div
          class="drag-drop-wrapper flex-col center-center gap-16"
          [class.error-msg]="!!errorKey()"
          appDragDropFileUpload
          (fileDropped)="onFileDrop($event)"
        >
          <div class="flex-row center-center drag-drop-icon icon-16" [class.drag-drop-icon-warning]="!!errorKey()">
            <span [class]="errorKey() ? 'ui-icon-warning' : 'ui-icon-image'"></span>
          </div>
          <h2>{{ uploadTitle() | translate }}</h2>
          <div class="drag-drop-description">
            {{ 'PERSONS.UPLOAD_DIALOG.DESCRIPTION' | translate }}
          </div>
          <ui-button type="primary" [text]="uploadButtonText() | translate" (clickAction)="fileInput.click()"></ui-button>
          <input #fileInput type="file" hidden accept="image/png,image/jpeg" name="file" (change)="onFileChange($event)" />
        </div>
      }
    } @else {
      @if (hasMatchingPerson()) {
        <div class="matching-wrapper w-100 flex-col start-start gap-16">
          <div>{{ 'PERSONS.UPLOAD_DIALOG.SAME_PERSON' | translate }}</div>
          <div class="matches w-100 flex-row center-start gap-16">
            <div class="flex-col center-center gap-8">
              <img [appAuthSrc]="bestImageUrl()" [appAuthSrcFallback]="bestImageUrl()" />
            </div>

            <div class="flex-col center-center gap-8">
              <img
                [appAuthSrc]="getMatchingPersonImage()"
                [appAuthSrcFallback]="getMatchingPersonImage(false)"
              />
              <div>{{ matchingPerson()?.name }}</div>
            </div>
          </div>
        </div>
      } @else {
        <div class="person-preview-wrapper w-100 flex-col center-center gap-16">
          <div class="person-preview p-r">
            <span class="ui-icon-info info-icon"></span>
            <img [appAuthSrc]="bestImageUrl()" [appAuthSrcFallback]="bestImageUrl()" />
          </div>
          <div class="name-input-wrapper w-100 flex-col gap-8">
            <label for="person-name">{{ 'PERSONS.UPLOAD_DIALOG.PERSON_NAME' | translate }}</label>
            <input
              id="person-name"
              class="ui-input"
              [placeholder]="'PERSONS.UPLOAD_DIALOG.TOOLTIPS.NAME' | translate"
              [formControl]="personNameForm"
            />
          </div>
        </div>
      }
    }
  </div>

  @if (!shouldShowUploadSection()) {
    <div class="footer flex-row end-center gap-8">
      @if (hasMatchingPerson()) {
        <ui-button
          type="secondary"
          [text]="'PERSONS.UPLOAD_DIALOG.NO' | translate"
          [disabled]="isAttaching()"
          (clickAction)="matchingNo()"
        ></ui-button>
        <ui-button
          type="primary"
          [text]="'PERSONS.UPLOAD_DIALOG.SAME_PERSON_CONFIRM' | translate"
          [disabled]="isAttaching()"
          [loading]="isAttaching()"
          (clickAction)="matchingYes()"
        ></ui-button>
      } @else {
        <ui-button
          type="secondary"
          [text]="'PERSONS.UPLOAD_DIALOG.BACK_TO_UPLOAD' | translate"
          [disabled]="isCreating()"
          (clickAction)="reset()"
        ></ui-button>
        <ui-button
          type="primary"
          [text]="'COMMON.SAVE' | translate"
          [disabled]="!canCreatePerson()"
          [loading]="isCreating()"
          (clickAction)="createPerson()"
        ></ui-button>
      }
    </div>
  }
</div>
